import { defineMessages } from 'react-intl';

export default defineMessages({
    driversLicenseNumber: {
        id: 'quoteandbind.ba.views.ba-confirmation.Drivers License Number',
        defaultMessage: 'Driver\'s License Number'
    },
    licenseState: {
        id: 'quoteandbind.ba.views.ba-confirmation.License State',
        defaultMessage: 'License State'
    },
    yearFirstLicensed: {
        id: 'quoteandbind.ba.views.ba-confirmation.Year First Licensed',
        defaultMessage: 'Year First Licensed'
    },
    carMakeTable: {
        id: 'quoteandbind.ba.views.ba-confirmation.Make',
        defaultMessage: 'Make'
    },
    carModelTable: {
        id: 'quoteandbind.ba.views.ba-confirmation.Model',
        defaultMessage: 'Model'
    },
    carLicensePlateTable: {
        id: 'quoteandbind.ba.views.ba-confirmation.License Plate',
        defaultMessage: 'License Plate'
    },
    coverageTable: {
        id: 'quoteandbind.ba.views.ba-confirmation.Coverage',
        defaultMessage: 'Coverage'
    },
    limitsTable: {
        id: 'quoteandbind.ba.views.ba-confirmation.Limits',
        defaultMessage: 'Limits'
    },
    firstName: {
        id: 'quoteandbind.ba.views.ba-confirmation.FirstName',
        defaultMessage: 'First Name'
    },
    lastName: {
        id: 'quoteandbind.ba.views.ba-confirmation.LastName',
        defaultMessage: 'Last Name'
    },
    phone: {
        id: 'quoteandbind.ba.views.ba-confirmation.Phone',
        defaultMessage: 'Phone'
    },
    email: {
        id: 'quoteandbind.ba.views.ba-confirmation.Email',
        defaultMessage: 'Email'
    },
    address: {
        id: 'quoteandbind.ba.views.ba-confirmation.Address',
        defaultMessage: 'Address'
    },
    driverDetails: {
        id: 'quoteandbind.ba.views.ba-confirmation.Driver Details',
        defaultMessage: 'Driver Details'
    },
    contactInformationDetails: {
        id: 'quoteandbind.ba.views.ba-confirmation.Contact Information Details',
        defaultMessage: 'Contact Information Details'
    },
    vehicleDetails: {
        id: 'quoteandbind.ba.views.ba-confirmation.Vehicle Details',
        defaultMessage: 'Vehicle Details'
    },
    coveragePremiumDetails: {
        id: 'quoteandbind.ba.views.ba-confirmation.Coverage Premium Details',
        defaultMessage: 'Coverage Premium Details'
    },
    policyIssuanceAccepted: {
        id: 'quoteandbind.ba.views.ba-confirmation.Policy Issuance Accepted',
        defaultMessage: 'Policy Issuance Accepted'
    }
});
